module.exports = __webpack_public_path__ + "img/Stab_S3.937dceac.svg";